export default "__VITE_ASSET__DRJ0Qj76__"